import Vue from "vue";
import Router from "vue-router";

import Epreuve from "@/view/Epreuve";
import Rassemblement from "@/view/Rassemblement";
import Challenge from "@/view/Challenge";
import ChallengeEquipe from "@/view/ChallengeEquipe";
import CourseCumul from "@/view/CourseCumul";
import CourseCumulEquipe from "@/view/CourseCumulEquipe";
import Import from "@/view/ImportSimplify";
import Admin from "@/view/Admin";
import Update from "@/view/Update";
import UpdateAndFix from "@/view/UpdateAndFix";
import Edit from "@/view/Edit";
import Home from "@/components/Home";
import AncienneEpreuve from "@/components/AncienneEpreuve";
import BuildDiploma from "@/components/BuildDiploma";
import GetDiploma from "@/components/GetDiploma";
import GetGDiploma from "@/components/GetGDiploma";
import ImportFont from "@/components/ImportFont";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/epreuve",
      name: "Epreuve",
      component: Epreuve,
      props: true,
    },
    {
      path: "/reclassement",
      name: "Rassemblement",
      component: Rassemblement,
      props: true,
    },
    {
      path: "/challenge",
      name: "Challenge",
      component: Challenge,
      props: true,
    },
    {
      path: "/challengeEquipe",
      name: "ChallengeEquipe",
      component: ChallengeEquipe,
      props: true,
    },
    {
      path: "/courseCumul",
      name: "CourseCumul",
      component: CourseCumul,
      props: true,
    },
    {
      path: "/courseCumulEquipe",
      name: "CourseCumulEquipe",
      component: CourseCumulEquipe,
      props: true,
    },
    {
      path: "/import",
      name: "Import",
      component: Import,
      props: true,
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      props: true,
    },
    {
      path: "/update",
      name: "Update",
      component: Update,
      props: true,
    },
    {
      path: "/update-and-fix",
      name: "UpdateAndFix",
      component: UpdateAndFix,
      props: true,
    },
    {
      path: "/edit",
      name: "Edit",
      component: Edit,
      props: true,
    },
    {
      path: "/epreuves",
      name: "Home",
      component: Home,
      props: true,
    },

    {
      path: "/ancienne-epreuve",
      name: "AncienneEpreuve",
      component: AncienneEpreuve,
      props: true,
    },
    {
      path: "/buildDiploma",
      name: "BuildDiploma",
      component: BuildDiploma,
      props: true,
    },
    {
      path: "/getDiploma",
      name: "GetDiploma",
      component: GetDiploma,
      props: true,
    },
    {
      path: "/getGDiploma",
      name: "GetGDiploma",
      component: GetGDiploma,
      props: true,
    },

    {
      path: "/importFont",
      name: "ImportFont",
      component: ImportFont,
      props: true,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js